import { IonButton, IonCard, IonCardContent, IonCol, IonIcon, IonInput, IonItem, IonList, IonRow, IonText } from "@ionic/react";
import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import { chevronBackOutline, chevronForwardOutline, search, searchOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import CustomDesplegable from "../../components/CustomDesplegable/CustomDesplegable";
import DialogoConfirmacion from "../../components/DialogoConfirmacion/DialogoConfirmacion";
import FichaPaciente from "../../components/FichaPaciente/FichaPaciente";
import { COLORS } from "../../constants/app";
import http from "../../hooks/httpAdapter";
import { useSession } from "../../hooks/SessionContext";
import useTituloPagina from "../../hooks/tituloPagina";
import { DesplegableModel, FechaFeriado, Prestador, Turno } from "../../interfaces";
import { borrarObjetosDuplicados, capitalizarPrimeraLetra, obtenerNombreDia, ordenarArrayObjetosByDate } from "../../utils/funcionalidadesIndex";
dayjs.locale("es");
dayjs.extend(localeData);

interface ContainerProps {}

const DarTurno: React.FC<ContainerProps> = ({}) => {
  const { pacienteCargado, hcUL, cargandoSession, setSesionInvalida, mostrarNotificacion, turnoSeleccionado: turnoDelContexto } = useSession();
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState<Prestador>({
    prestadorCod: 0,
    prestadorNom: "",
    especialidadNom: "",
  });

  const [observaciones, setObservaciones] = useState<string>("");
  const [turnosAgenda, setTurnosAgenda] = useState<Turno[]>([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState<Turno>({
    codigo: 0,
    prestadorCod: 0,
    paciente: 0,
    pacienteNom: "",
    pacienteDocumento: 0,
    especialidadCod: 0,
    mutual: 0,
    mutualNom: "",
    servicio: 0,
    prestadorNom: "",
    origenTurno: "",
    especialidadNom: "",
    atendidoHora: "",
    fechaOrigen: "",
    horaOrigen: "",
    observaciones: "",
    fecha: "",
    hora: "",
    libre: true,
    asistio: false,
    telemedicina: false,
    cancelado: false,
    reservado: false,
    entreTurno: false,
    evolucion: 0,
  });
  const [disabledPrevFecha, setDisabledPrevFecha] = useState(true);
  const [disabledSigFecha, setDisabledSigFecha] = useState(true);
  const [fechaSelect, setFechaSelect] = useState<DesplegableModel>({
    codigo: dayjs().unix(),
    text: dayjs().format("YYYY-MM-DD"),
    nota: "",
  });
  const [fechasDisponibles, setFechasDisponibles] = useState<DesplegableModel[]>([]);
  const [openFechaSelect, setOpenFechaSelect] = useState(false);
  const [abrirModalConfirmarReserva, setAbrirModalConfirmarReserva] = useState(false);

  const history = useHistory();
  useTituloPagina();

  const verificarEsFeriado = async (fecha: FechaFeriado) => {
    try {
      var config = {
        headers: { Authorization: `Bearer ${hcUL?.token}` },
      };
      if (fecha.fecha !== "" && fecha !== null) {
        await http()
          .get(`Servicios/TraerFeriado?fecha=${dayjs(fecha.fecha).format("YYYY/MM/DD")}`, config) //@ts-ignore
          .then((response) => {
            //@ts-ignore
            if (response.length !== 0) {
              //@ts-ignore
              fecha.esFeriado = response[0].esFeriado;
            }
          })
          .catch((e) => {
            if (e.response && e.response.status === 401) {
              setSesionInvalida(true);
              // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
            } else {
              console.error(e);
            }
          });
      }
    } catch (e) {
      mostrarNotificacion(true, "Ocurrio un problema al verificar si " + dayjs(fecha.fecha).format("DD/MM/YYYY") + " es feriado", "rojo");
    }
  };

  const traerTurnosAgenda = async (prestador: Prestador) => {
    let agenda: Turno[] = [];
    let fechasTurnos: FechaFeriado[] = [];

    var config = {
      headers: { Authorization: `Bearer ${hcUL?.token}` },
    };
    if (prestador && prestador.prestadorCod !== 0) {
      try {
        let response = await http()
          .get(
            `Turnos/TurnosPrestadorFecha/?prestador=${prestador.prestadorCod}&desde=${dayjs().format("YYYY/MM/DD hh:mm")}&hasta=${dayjs()
              .add(3, "month")
              .format("YYYY/MM/DD hh:mm")}`,

            config
          )
          .catch((e) => {
            if (e.response && e.response.status === 401) {
              setSesionInvalida(true);
              // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
            } else {
              console.error(e);
            }
          });

        if (response.length !== 0) {
          agenda = response;
        }

        agenda = ordenarArrayObjetosByDate(agenda, "hora");

        borrarObjetosDuplicados(agenda, "fecha", true).map((turno) => {
          fechasTurnos.push({ fecha: turno, esFeriado: false });
        });

        fechasTurnos.map(async (fecha) => {
          await verificarEsFeriado(fecha);
        });

        let desplegableFechas: DesplegableModel[] = fechasTurnos.map((fecha: FechaFeriado) => {
          return {
            codigo: dayjs(fecha.fecha).unix(),
            text: `${obtenerNombreDia(dayjs(fecha.fecha).format("dddd"))} ${dayjs(fecha.fecha).format("DD")} de ${dayjs(fecha.fecha).format(
              "MMMM, YYYY"
            )}`,
            nota: fecha.esFeriado ? "Feriado" : "",
          };
        });

        // NO sobrescribir fechaSelect si ya tenemos una fecha del turno preseleccionado
        if (!turnoDelContexto || turnoDelContexto.codigo === 0) {
          setFechaSelect(desplegableFechas[0]);
        }

        setFechasDisponibles(desplegableFechas);
        setTurnosAgenda(agenda);
      } catch (e) {
        mostrarNotificacion(
          true,
          //@ts-ignore
          "Error: " + e,
          "rojo"
        );
      }
    }
  };

  useEffect(() => {
    // Solo usar prestador logueado si el prestador actual es inicial (código 0) Y no hay turno del contexto
    if (prestadorSeleccionado.prestadorCod === 0 && hcUL && hcUL.prestadorCod > 0 && (!turnoDelContexto || turnoDelContexto.codigo === 0)) {
      const prestadorLogueado: Prestador = {
        prestadorCod: hcUL.prestadorCod,
        prestadorNom: hcUL.prestadorNom,
        especialidadNom: hcUL.especialidadNom,
      };

      setPrestadorSeleccionado(prestadorLogueado);
      traerTurnosAgenda(prestadorLogueado);
    }
  }, [hcUL, pacienteCargado]);

  // NUEVO useEffect - Para manejar turno preseleccionado desde la agenda
  useEffect(() => {
    if (turnoDelContexto && turnoDelContexto.prestadorCod > 0) {
      // Si hay un turno del contexto (preseleccionado o plantilla)
      setTurnoSeleccionado(turnoDelContexto);

      // IMPORTANTE: Establecer la fecha del turno preseleccionado
      const fechaTurno: DesplegableModel = {
        codigo: dayjs(turnoDelContexto.fecha).unix(),
        text: `${dayjs(turnoDelContexto.fecha).format("dddd DD")} de ${dayjs(turnoDelContexto.fecha).format("MMMM, YYYY")}`,
        nota: "",
      };
      setFechaSelect(fechaTurno);

      // También actualizar el prestador con los datos del turno
      const prestadorDelTurno: Prestador = {
        prestadorCod: turnoDelContexto.prestadorCod,
        prestadorNom: turnoDelContexto.prestadorNom,
        especialidadNom: turnoDelContexto.especialidadNom,
      };

      setPrestadorSeleccionado(prestadorDelTurno);

      // Traer la agenda de ese prestador específico
      traerTurnosAgenda(prestadorDelTurno);
    }
  }, [turnoDelContexto]);

  const handleChangeSelect = (value: any, select: string) => {
    switch (select) {
      case "Fecha":
        let fecha: DesplegableModel = {
          codigo: dayjs().unix(),
          text: `${obtenerNombreDia(dayjs().format("dddd"))} ${dayjs().format("DD")} de ${dayjs().format("MMMM, YYYY")}`,
          nota: "",
        };
        fechasDisponibles.forEach((dia) => {
          if (dia.codigo === value) fecha = dia;
        });
        setFechaSelect(fecha);
        break;
      default:
        mostrarNotificacion(true, "Selección inválida", COLORS.ERROR);
        break;
    }
  };

  const handleClickBotonFecha = (signo: string) => {
    let fechaSel: DesplegableModel = fechaSelect;
    let indice: number = fechasDisponibles.findIndex((fecha) => fecha === fechaSel);
    if (signo === "+") fechaSel = fechasDisponibles[indice + 1];
    if (signo === "-") fechaSel = fechasDisponibles[indice - 1];

    handleChangeSelect(fechaSel.codigo, "Fecha");
  };

  useEffect(() => {
    const currentIndex = fechasDisponibles.findIndex((fecha) => fecha === fechaSelect);
    setDisabledPrevFecha(currentIndex === 0);
    setDisabledSigFecha(currentIndex === fechasDisponibles.length - 1);
  }, [fechasDisponibles, fechaSelect]);

  const togleAbrirCerrarConfirmarReserva = () => {
    if (abrirModalConfirmarReserva) {
      setTurnoSeleccionado({
        codigo: 0,
        prestadorCod: 0,
        paciente: 0,
        pacienteNom: "",
        pacienteDocumento: 0,
        especialidadCod: 0,
        mutual: 0,
        mutualNom: "",
        servicio: 0,
        prestadorNom: "",
        origenTurno: "",
        especialidadNom: "",
        atendidoHora: "",
        fechaOrigen: "",
        horaOrigen: "",
        observaciones: "",
        fecha: "",
        hora: "",
        libre: true,
        asistio: false,
        telemedicina: false,
        cancelado: false,
        reservado: false,
        entreTurno: false,
        evolucion: 0,
      });
    }
    setAbrirModalConfirmarReserva(!abrirModalConfirmarReserva);
  };

  const handleClickConfirmarHacerReserva = async () => {
    if (pacienteCargado !== null && pacienteCargado.codigo !== 0) {
      await actualizarTurno();
      togleAbrirCerrarConfirmarReserva();
      await traerTurnosAgenda(prestadorSeleccionado);
    } else {
      mostrarNotificacion(true, "No se encuentra un paciente seleccionado", COLORS.ERROR);
    }
  };

  const SeleccionarTurno = (turno: Turno) => {
    if (pacienteCargado === null || pacienteCargado?.codigo === 0) {
      mostrarNotificacion(true, "Debe ingresar un paciente", COLORS.ERROR);
    } else {
      if (turno.paciente !== 0) {
        mostrarNotificacion(true, "Turno ya asignado a otro paciente", COLORS.ERROR);
      } else {
        setTurnoSeleccionado(turno);
        togleAbrirCerrarConfirmarReserva();
      }
    }
  };

  const actualizarTurno = async () => {
    let actualizarTurnoEstado = 0;
    let url = `Turnos/DarTurno/${turnoSeleccionado.codigo}`;

    let respuesta = "";
    let errorAxios = "";
    let blnErrorAxios = false;

    var config = {
      headers: { Authorization: `Bearer ${hcUL?.token}` },
    };
    if (pacienteCargado !== null) {
      if (turnoSeleccionado) {
        try {
          const response = await http()
            .put(
              url,
              {
                codigo: turnoSeleccionado.codigo,
                paciente: pacienteCargado?.codigo,
                estudio: null, // si es estudio, codigo Estudio, sino Null
                mutual: pacienteCargado?.mutual,
                dioturno: hcUL?.codigo,
                observaciones: observaciones,
              },

              config
            )
            .catch((e) => {
              if (e.response && e.response.status === 401) {
                setSesionInvalida(true);
                // history.push("/", { motivoRedireccion: "401" }); // Redirección en caso de error 401
              } else {
                console.error(e);
              }
            });
          actualizarTurnoEstado = response.status;
          respuesta = response.statusText;
        } catch (error) {
          //@ts-ignore
          errorAxios = error.response.message;
          blnErrorAxios = true;
        }

        if (!blnErrorAxios) {
          mostrarNotificacion(true, "El turno se Registro Correctamente", COLORS.SUCCESS);
        } else {
          mostrarNotificacion(true, errorAxios, COLORS.ERROR);
        }
      } else {
        mostrarNotificacion(true, errorAxios, COLORS.ERROR);
      }
    } else {
      mostrarNotificacion(true, "No hay un paciente seleccionado", COLORS.ERROR);
    }
  };

  const renderTurnos = () => {
    let turnos = turnosAgenda.filter((turno) => dayjs(turno.fecha).unix() === fechaSelect.codigo);

    // Si hay un turno del contexto (venimos desde agenda), mostrar solo turnos libres
    // Si no hay turno del contexto (Nuevo Turno normal), mostrar toda la agenda
    if (turnoDelContexto && turnoDelContexto.codigo > 0) {
      // Venimos desde agenda - mostrar solo turnos libres para elegir alternativas
      turnos = turnos.filter((turno) => turno.libre === true);
    }

    // Si es el día actual, filtrar turnos futuros (aplicar a ambos modos)
    if (dayjs().format("YYYY/MM/DD") === dayjs.unix(fechaSelect.codigo).format("YYYY/MM/DD")) {
      turnos = turnos.filter((turno) => dayjs(turno.hora).unix() > dayjs().unix());
    }

    return turnos.map((turno: Turno) => {
      // Verificar si este es el turno preseleccionado desde la agenda
      const esTurnoPreseleccionado =
        turnoDelContexto &&
        turno.codigo === turnoDelContexto.codigo &&
        dayjs(turno.hora).format("HH:mm") === dayjs(turnoDelContexto.hora).format("HH:mm");

      return (
        <IonItem
          className="fila ion-align-items-center"
          key={turno.codigo}
          button={turno.libre} // Solo clickeable si está libre
          onClick={turno.libre ? (e) => SeleccionarTurno(turno) : undefined}
          style={
            esTurnoPreseleccionado
              ? {
                  backgroundColor: "var(--ion-color-light)",
                  border: "2px solid var(--ion-color-secondary)",
                  borderRadius: "8px",
                  margin: "2px 0",
                }
              : turno.libre
              ? {}
              : {
                  backgroundColor: "var(--ion-color-light)",
                  cursor: "default",
                }
          }
        >
          <IonCol className="celda" size="3">
            <small style={esTurnoPreseleccionado ? { fontWeight: "bold", color: "var(--ion-color-secondary)" } : {}}>
              {dayjs(turno.hora).format("HH:mm")}
              {esTurnoPreseleccionado && <span style={{ marginLeft: "5px" }}></span>}
            </small>
          </IonCol>
          <IonCol className="celda" size="6">
            <small style={esTurnoPreseleccionado ? { fontWeight: "bold", color: "var(--ion-color-secondary)" } : {}}>
              {esTurnoPreseleccionado && "Turno preseleccionado - "}
              {turno.observaciones === ""
                ? turno.libre === false
                  ? turno.pacienteNom
                  : ""
                : turno.libre === false
                ? turno.pacienteNom + " - " + turno.observaciones
                : turno.observaciones}
            </small>
          </IonCol>
        </IonItem>
      );
    });
  };

  return (
    <IonCard>
      <IonCardContent>
        <IonRow>
          <IonCol size="12">
            <FichaPaciente recargarPagina={false} mostrarBuscarOtro={true} />
          </IonCol>
        </IonRow>
        {pacienteCargado !== null && pacienteCargado?.codigo !== 0 && (
          <>
            <IonText>
              <IonRow>
                <IonCol size="12" sizeMd="6">
                  <IonItem>
                    <IonInput label="Especialidad:" placeholder={prestadorSeleccionado.especialidadNom} readonly />
                  </IonItem>
                </IonCol>
                <IonCol size="12" sizeMd="6">
                  <IonItem>
                    <IonInput label="Prestador:" placeholder={prestadorSeleccionado.prestadorNom} readonly />
                  </IonItem>
                </IonCol>
              </IonRow>

              <IonRow>
                <IonCol size="12">
                  <IonItem lines="none">
                    <IonInput
                      label="Observacion:"
                      placeholder="Comentario del turno"
                      value={observaciones}
                      //@ts-ignore
                      onKeyUp={(e) => setObservaciones(e.target.value)}
                      maxlength={80}
                      counter={true}
                    />
                  </IonItem>
                </IonCol>
              </IonRow>
            </IonText>
            <IonRow>
              {prestadorSeleccionado.prestadorCod !== -1 && prestadorSeleccionado.prestadorCod !== 0 && fechasDisponibles.length !== 0 && (
                <IonCol size="12">
                  <IonItem>
                    <IonButton
                      slot="start"
                      color="dark"
                      onClick={() => handleClickBotonFecha("-")}
                      disabled={disabledPrevFecha}
                      expand="block"
                      fill="clear"
                    >
                      <IonIcon icon={chevronBackOutline} size="large" />
                    </IonButton>

                    <IonInput
                      readonly
                      label="Fecha"
                      label-placement="floating"
                      id="fecha"
                      value={fechaSelect.text}
                      onClick={() => setOpenFechaSelect(true)}
                    />
                    <IonButton slot="end" fill="clear" onClick={() => setOpenFechaSelect(true)}>
                      <IonIcon aria-hidden="true" ios={searchOutline} md={search} size="large" />
                    </IonButton>

                    <IonButton
                      slot="end"
                      color="dark"
                      onClick={() => handleClickBotonFecha("+")}
                      disabled={disabledSigFecha}
                      expand="block"
                      fill="clear"
                    >
                      <IonIcon icon={chevronForwardOutline} size="large" />
                    </IonButton>
                  </IonItem>
                </IonCol>
              )}
            </IonRow>
            {dayjs().format("YYYY/MM/DD") === dayjs.unix(fechaSelect.codigo).format("YYYY/MM/DD")
              ? turnosAgenda.filter((turno) => dayjs(turno.hora).unix() >= dayjs().unix()).length > 0
              : turnosAgenda.filter((turno) => dayjs(turno.fecha).unix() === fechaSelect.codigo).length > 0 && (
                  <IonRow>
                    <IonCol size="12">
                      {/* Mensaje informativo cuando hay turno preseleccionado */}
                      {turnoDelContexto && turnoDelContexto.codigo > 0 && (
                        <IonCard color="primary" style={{ marginBottom: "10px" }}>
                          <IonCardContent style={{ padding: "12px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <span style={{ marginRight: "8px" }}></span>
                              <small style={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
                                Elije el turno preseleccionado ({dayjs(turnoDelContexto.hora).format("HH:mm")}) o puedes seleccionar otro horario
                                libre
                              </small>
                            </div>
                          </IonCardContent>
                        </IonCard>
                      )}

                      <IonList>
                        <IonItem className="fila ion-align-items-center">
                          <IonCol className="celda" size="3">
                            <small>Hora</small>
                          </IonCol>
                          <IonCol className="celda" size="6">
                            <small>Paciente / Observacion</small>
                          </IonCol>
                        </IonItem>
                        {renderTurnos()}
                      </IonList>
                    </IonCol>
                  </IonRow>
                )}
          </>
        )}
        {pacienteCargado !== null && pacienteCargado?.codigo !== 0 && (
          <>
            {prestadorSeleccionado.prestadorCod !== -1 && prestadorSeleccionado.prestadorCod !== 0 && fechasDisponibles.length !== 0 && (
              <CustomDesplegable
                id="Fecha"
                open={openFechaSelect}
                setOpen={setOpenFechaSelect}
                array={fechasDisponibles}
                value={fechaSelect.codigo}
                handleChange={handleChangeSelect}
                mostrarTodos={false}
                mostrarSearch={false}
              />
            )}
          </>
        )}
        <DialogoConfirmacion
          titulo="Reservar turno"
          contenido={`Ha seleccionado el turno con el/la prestador/a ${turnoSeleccionado.prestadorNom}, con especialidad en ${
            turnoSeleccionado.especialidadNom
          }, para el dia ${capitalizarPrimeraLetra(dayjs(turnoSeleccionado.fecha).format("dddd DD, MM/YYYY"))}, a las ${dayjs(
            turnoSeleccionado.hora
          ).format("HH:mm")}, ¿es esto correcto?`}
          abrirCerrarModal={abrirModalConfirmarReserva}
          handleclickBotonNo={togleAbrirCerrarConfirmarReserva}
          handleclickBotonSi={handleClickConfirmarHacerReserva}
          colorBotonNo="amarillo"
          colorBotonSi="verde"
          textoBotonNo="No, revisar"
          textoBotonSi="Si, Confirmar"
        />
      </IonCardContent>
    </IonCard>
  );
};

export default DarTurno;
